import { FunctionComponent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Event, EventLocationType } from '../../../../../services';
import { IconLabel } from '../../../IconLabel';

import classes from './EventLocation.module.scss';

interface EventLocationProps {
  event: Event;
}

export const EventLocation: FunctionComponent<EventLocationProps> = memo(({ event }) => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'eventItem' });

  const { location } = event;

  const locationContent = useMemo(() => {
    const { type, address, virtualUrl } = location;

    if (type === EventLocationType.IN_PERSON && address) {
      return (
        <a
          href={`https://maps.google.com/?q=${encodeURIComponent(address)}`}
          target={'_blank'}
          rel={'noreferrer'}
          className={classes['event-location__link']}
          onClick={(e) => e.stopPropagation()}
        >
          {ctxT('in-person', { address, interpolation: { escapeValue: false } })}
        </a>
      );
    }

    if (type === EventLocationType.VIRTUAL && virtualUrl) {
      return (
        <a
          href={virtualUrl}
          target={'_blank'}
          rel={'noreferrer'}
          className={classes['event-location__link']}
          onClick={(e) => e.stopPropagation()}
        >
          {ctxT('online', { url: virtualUrl, interpolation: { escapeValue: false } })}
        </a>
      );
    }

    return null;
  }, [location, ctxT]);

  if (!locationContent) {
    return null;
  }

  return (
    <div className={classes['event-location']}>
      <IconLabel iconId={'location'} iconSize={16} nonClickable singleColor />
      {locationContent}
    </div>
  );
});
